import {
  SkeletonText,
  SkeletonWrapper,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

export const footerWrapperCss = css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div:last-of-type {
    justify-content: flex-end;
  }
`

export const FooterLoader = () => (
  <div css={footerWrapperCss}>
    <SkeletonText width={260} height={14} />
    <SkeletonWrapper>
      <SkeletonText width={60} height={30} />
      <SkeletonText width={60} height={30} />
    </SkeletonWrapper>
  </div>
)

export default FooterLoader
